export default {"src":"/_next/static/media/PurplePreviousArrow.de64d9ca.svg","height":43,"width":42,"blurWidth":0,"blurHeight":0};